export function mapObbPassengersForApi(passengerList: Array<any>) {
  return passengerList.map(({ hasRemove: _hasRemove, ...passenger }) => passenger);
}
